<template>
	<section class="container ly_mw-68 ly_col-48"><slot></slot></section>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.container {
	font-size: var(--font-s-xx-large);
	font-weight: var(--font-w-bold);
	line-height: 3rem;
}
</style>
